
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ActivityForm } from "./ActivityForm";
import { Tables } from "@/integrations/supabase/types";

type Activity = Tables<"activities">;
type ActivityCategory = Tables<"activity_categories">;

interface ActivityEditDialogProps {
  activity: Activity | null;
  categories: ActivityCategory[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (activity: any) => Promise<boolean>;
}

export const ActivityEditDialog = ({ 
  activity, 
  categories,
  open, 
  onOpenChange, 
  onSave 
}: ActivityEditDialogProps) => {
  const handleSave = async (activityData: any) => {
    const success = await onSave(activityData);
    if (success) {
      onOpenChange(false);
    }
    return success;
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {activity ? "Edit Activity" : "Create New Activity"}
          </DialogTitle>
        </DialogHeader>
        <ActivityForm
          activity={activity || undefined}
          categories={categories}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};
